import * as Ink from "inkjs"
import LocalStorage from "local-storage-json"
import Dev from "@frog/source/models/admin/Dev.js"
import Navigation from "@frog/source/models/Navigation.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"

// TODO: don't hardcode this to a single game, have
// this be passed in when calling for ink dialogue
import STORY from "@frog/source/data/games/pirates/script.ink.json"

export default new class {
    constructor() {
        if(Dev.isEnabled == true
        && LocalStorage.get("ink") != undefined) {
            this.story = new Ink.Story(LocalStorage.get("ink"))
            console.log("%cInk: We are using a locally uploaded script. To drop this script, run ink.wipe()", "color: green")
            // document.documentElement.style.backgroundColor = "hotpink"
        } else {
            this.story = new Ink.Story(STORY)
        }

        window.ink = {
            "wipe": function() {
                LocalStorage.remove("ink")
                window.location.reload()
            },
            "reset": () => {
                this.loadDialogue("reset_run")
            },
            "endgame": () => {
                this.loadDialogue("endgame")
            }
        }
        this.story.onError = function(error) {
            console.error(error)
        }
    }
    loadDialogue(knotname, stage) {
        try {
            this.story.ChoosePathString(knotname)
            return this.loadNextDialogue(stage)
        } catch(error) {
            if(error.name != "StoryException") console.log(error)
            // console.log("Could not find narrative trigger: " + knotname)
            return []
        }
    }
    loadNextDialogue(stage) {
        const dialogues = []
        const scriptLines = []

        while(this.story.canContinue) {
            stage.dialogue.portraitScene = structuredClone(stage.dialogue.portraitScene)

            let words = this.story.Continue()
            const scriptLine = {
                "words": [],
                "tags": {}
            }

            // Plotscript Checks
            const splitWords = words.split(" ").map((word) => word.trim())
            if(splitWords[0] == ">"
            && splitWords[1] == "CHECKS") {
                let options = {}
                const plotscriptName = splitWords[2]
                splitWords.shift()
                splitWords.shift()
                splitWords.shift()
                for(let word of splitWords) {
                    const optionKey = word.split(":")[0]
                    const optionValue = word.split(":")[1]
                    options[optionKey] = optionValue
                }
                this.story.variablesState.returnedCheck = PlotConditions[plotscriptName](stage, options)
            } else {
                scriptLine.words = words
                scriptLine.tags = this.story.currentTags

                scriptLines.push(scriptLine)
            }
        }

        return scriptLines
    }
    set(key, value) {
        try {
            this.story.variablesState[key] = value
        } catch(error) {
            console.log(error)
            console.log("Could not find state variable: " + key)
            return []
        }
    }
    increment(key, value) {
        if(value === undefined) {
            value = 1
        }
        try {
            this.story.variablesState[key] = this.story.variablesState[key] || 0
            this.story.variablesState[key] = this.story.variablesState[key] + 1
            console.log(this.story.variablesState[key])
        } catch(error) {
            console.log(error)
            console.log("Could not find state variable: " + key)
            return []
        }
    }
}

// story.BindExternalFunction("unlock", (key) => {
//     console.log("UNLOCKING", key)
// })

// function showAfter(delay, el, text, style = "color: #000") {
//     setTimeout(function() { console.log("%c " + text, style) }, delay)
//     // setTimeout(function() { el.classList.add("show") }, delay)
// }

////////////////////
// Ink Dev Tools //
//////////////////

if(Dev.isEnabled == true && false) {
    document.getElementById("dev").addEventListener("dragenter", function(event) {
        document.getElementById("dev").setAttribute("juiced", true)
    })

    document.getElementById("dev").addEventListener("dragleave", function(event) {
        document.getElementById("dev").setAttribute("juiced", false)
    })

    document.getElementById("dev").addEventListener("dragover", function(event) {
        event.stopPropagation()
        event.preventDefault()
    })

    document.getElementById("dev").addEventListener("contextmenu", function(event) {
        event.stopPropagation()
        event.preventDefault()
    })

    document.getElementById("dev").addEventListener("drop", function(event) {
        event.stopPropagation()
        event.preventDefault()

        document.getElementById("dev").setAttribute("juiced", false)

        const files = event.dataTransfer.files
        Array.from(files).forEach((file) => {
            if(file.type.match("application/json") == false) {
                return
            }
            const reader = new FileReader()
            reader.addEventListener("load", function(event) {
                try {
                    const json = JSON.parse(event.target.result)
                    LocalStorage.set("ink", json)
                    window.location.reload()

                } catch(error) {
                    console.error("Failed to parse the file as JSON:", error)
                }
            })
            reader.readAsText(file)
        })
    })
}
